import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownOptions from './Components/DropdownOptionsView';
import { optionsWithVisibilitySet, optionsFiltered, firstItem } from './SingleOptionDropdownAux';
import { Wrapper, SearchInput, StyledResults, ScrollWrapper } from './StyledComponents';

class CustomDropDown extends Component {
  constructor(props) {
    super(props);
    const { value, options } = this.props;

    const emptyValue = {
      label: '',
      value: '',
    };

    this.state = {
      canClose: true,
      options,
      isOpen: false,
      pristineOptions: optionsWithVisibilitySet(options),
      pristineValue: value || emptyValue,
      value: value || emptyValue,
      hasFilter: false,
    };
  }

  componentDidUpdate() {
    if (this.state.canClose && !this.state.isOpen && this.dropdown.classList.contains('open')) {
      // IE needs this
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        isOpen: false,
      });
    }

    if (this.state.isOpen && this.props.openDirectionUp) {
      const height = this.resultsContainer.offsetHeight;
      this.resultsContainer.style.top = `-${height}px`;
    }
  }

  render() {
    const { onChange, placeholder, openDirectionUp, className, onFocus, onBlur } = this.props;

    const { isOpen, options, pristineOptions, pristineValue, value, hasFilter } = this.state;

    const isSameTermAsPristineValue = value.label === pristineValue.label;

    return (
      <Wrapper
        className={`
          ${className}
          ${isOpen ? 'open' : ''}
        `}
        isOpen={isOpen}
        onMouseEnter={() => {
          this.setState({
            canClose: false,
          });
        }}
        onMouseLeave={() => {
          if (this.state.isOpen) {
            this.setState({
              canClose: true,
            });
          }
        }}
        onFocus={() => {
          this.input.focus();
        }}
        ref={dropdown => {
          this.dropdown = dropdown;
        }}
      >
        <SearchInput
          type="text"
          value={value.label}
          placeholder={placeholder}
          id={this.props.id}
          autocomplete="off"
          ref={input => {
            this.input = input;
          }}
          onBlur={ev => {
            if (this.state.canClose) {
              this.setState({
                isOpen: false,
              });
            }

            onBlur(ev);
          }}
          onFocus={ev => {
            this.setState({
              isOpen: true,
            });

            onFocus(ev);
          }}
          onClick={() => {
            if (!this.state.isOpen) {
              this.setState({
                isOpen: true,
              });
            }
          }}
          onKeyDown={event => {
            const DELETE = 46;
            const ENTER = 13;
            const TAB = 9;
            const key = parseInt(event.keyCode, 10) || parseInt(event.charCode, 10);
            if (key === DELETE) {
              this.setState({
                value: {
                  label: '',
                },
                options: pristineOptions,
              });
              event.preventDefault();
              return false;
            }
            if (key === ENTER) {
              if (hasFilter) {
                const firstOption = firstItem(hasFilter, options);
                this.setState({
                  value: firstOption,
                  options: optionsWithVisibilitySet(options),
                  isOpen: false,
                });

                onChange(firstOption);
              }
              this.input.focus();
              event.preventDefault();
              return false;
            }
            if (key === TAB) {
              this.input.blur();
              this.setState({
                isOpen: false,
              });
              return true;
            }

            this.setState({
              isOpen: true,
            });

            return true;
          }}
          onChange={event => {
            const { target } = event;
            const { value: currentValue } = target;
            const matchQuestionMark = pristineOptions.find(option => option.label === currentValue);
            if (matchQuestionMark) {
              onChange(matchQuestionMark);
            }
            this.setState({
              value: {
                label: currentValue,
              },
              hasFilter: currentValue !== '',
              options: optionsFiltered(pristineOptions, currentValue),
              isOpen: true,
            });
          }}
        />

        <ScrollWrapper
          isOpen={isOpen}
          openDirectionUp={openDirectionUp}
          ref={resultsContainer => {
            this.resultsContainer = resultsContainer;
          }}
        >
          <StyledResults
            onMouseMove={() => {
              this.input.focus();
            }}
          >
            <DropdownOptions
              options={options}
              hasFilter={hasFilter}
              isSameTermAsPristineValue={isSameTermAsPristineValue}
              onChange={onChange}
              focusOnTheInput={() => this.input.focus}
              setState={option => {
                this.setState({
                  value: option,
                  isOpen: false,
                });
              }}
              pristineValue={pristineValue}
            />
          </StyledResults>
        </ScrollWrapper>
      </Wrapper>
    );
  }
}

CustomDropDown.defaultProps = {
  placeholder: '',
  openDirectionUp: false,
  id: '',
  className: '',
  onFocus: () => {},
  onBlur: () => {},
  value: {},
};

CustomDropDown.propTypes = {
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  openDirectionUp: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

CustomDropDown.Input = SearchInput;

export default CustomDropDown;
